module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    attrs: {
      "id": "f3dCanvas"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.down($event)
      },
      "mouseup": function($event) {
        $event.preventDefault();
        return _vm.up($event)
      },
      "mousemove": function($event) {
        $event.preventDefault();
        return _vm.move($event)
      },
      "touchstart": _vm.t_down,
      "touchend": _vm.t_up,
      "touchmove": _vm.t_move
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a4ecb80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/F3dCanvas.vue
// module id = 28
// module chunks = 0